exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.miniWidth {\n\twidth: 30px;\n}\n.no-border {\n\tborder: none;\n}\n.custom-control-input:checked ~ .custom-control-label::before {\n\tcolor: #fff;\n\tborder-color: #00a09c;\n\tbackground-color: #00a09c;\n\tborder: 2px solid white;\n}\n.info {\n\tfont-size: 16px;\n\tcolor: #225cbd;\n}\n.fs-15 {\n\tfont-size: 15px;\n}\n.align-center {\n\talign-items: center;\n}\n", ""]);

// exports
